"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _reactPopover = _interopRequireDefault(require("react-popover")),
    _clientAuth = require("@devsta/client-auth"),
    _classnames = _interopRequireDefault(require("classnames")),
    _EditableComment = _interopRequireDefault(require("./EditableComment")),
    _Replies = _interopRequireDefault(require("./Replies"));

require("../styles/_comment-popover.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var CommentPopover = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.onUpdateCheckbox = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b, c, e, f, g, h, i;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return b = d.props, c = b.updateComment, e = b.comment, f = e.isResolved, g = e.commentId, a.next = 3, c(g, {
                isResolved: !f
              });

            case 3:
              if (h = a.sent, i = h.error, !(i || f)) {
                a.next = 7;
                break;
              }

              return a.abrupt("return");

            case 7:
              d.toggleEditMode({
                toggle: !1
              });

            case 8:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), d.toggleEditMode = function (a) {
      var b = a.toggle,
          c = d.props.comment.isResolved;
      b && c || d.setState({
        editMode: b
      });
    }, d.renderContent = function () {
      var a = d.props,
          b = a.comment,
          c = a.updateComment,
          e = a.createReply,
          f = a.deleteComment,
          g = a.onDeleteComment,
          h = a.deleteReply,
          i = a.closePopover,
          j = a.canResolveComment,
          k = a.isReadOnly,
          l = a.resourceOrganisationId,
          m = d.state.editMode;
      return _react["default"].createElement("div", {
        className: "comment-popover__container"
      }, _react["default"].createElement("div", {
        className: "comment-popover__container__editable-comment-wrapper"
      }, _react["default"].createElement(_EditableComment["default"], {
        onDeleteComment: g,
        comment: b,
        updateComment: c,
        createReply: e,
        closePopover: i,
        deleteComment: f,
        canResolveComment: j,
        onUpdateCheckbox: d.onUpdateCheckbox,
        editMode: m,
        toggleEditMode: d.toggleEditMode,
        isReadOnly: k,
        resourceOrganisationId: l
      })), _react["default"].createElement("div", {
        className: "comment-popover__container__replies-wrapper"
      }, _react["default"].createElement(_Replies["default"], {
        createReply: e,
        deleteReply: h,
        closePopover: i,
        comment: b,
        isReadOnly: k,
        resourceOrganisationId: l
      })));
    }, d.state = {
      editMode: !1
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var a = this.props,
          b = a.updateViewers,
          c = a.comment,
          d = c.commentId,
          e = c.createdByUser.userId,
          f = c.viewers,
          g = void 0 === f ? [] : f,
          h = _clientAuth.credentials.get(),
          i = h.user.userId,
          j = g.find(function (a) {
        return a.userId === i;
      });

      j || e === i || b({
        commentId: d
      });
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.children,
          c = a.closePopover,
          d = a.appendTarget;
      return _react["default"].createElement(_reactPopover["default"], (0, _extends2["default"])({
        isOpen: !0,
        preferPlace: "right",
        body: this.renderContent(),
        tipSize: .01,
        onOuterAction: c,
        enterExitTransitionDurationMs: 0,
        className: (0, _classnames["default"])("comment-popover"),
        appendTarget: d
      }, this.props), b);
    }
  }]), b;
}(_react.Component),
    _default = CommentPopover;

exports["default"] = _default;